import {Id} from '../types';

export class StockRecordFuturePrice {
  id: Id;
  price = 0;
  date: Date = null;
}
